import { render, staticRenderFns } from "./GestionRecolector.vue?vue&type=template&id=80449c7c&scoped=true"
import script from "./GestionRecolector.vue?vue&type=script&lang=js"
export * from "./GestionRecolector.vue?vue&type=script&lang=js"
import style0 from "./GestionRecolector.vue?vue&type=style&index=0&id=80449c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80449c7c",
  null
  
)

export default component.exports